// Generated by go-ts-exporter. DO NOT EDIT.

export const photoURL = {
  DefaultGuestPhotoRelPath: "/images/guest-avatar.png",
  DefaultGuestPhotoFQLURL: "https://storytell.ai/images/guest-avatar.png",
  DefaultGuestPhotoFilename: "guest-avatar.png",
} as const;

export type photoURL = typeof photoURL[keyof typeof photoURL];
